import { render, staticRenderFns } from "./ItemCrud.vue?vue&type=template&id=421f90e6&scoped=true&"
import script from "./ItemCrud.vue?vue&type=script&lang=js&"
export * from "./ItemCrud.vue?vue&type=script&lang=js&"
import style0 from "./ItemCrud.vue?vue&type=style&index=0&id=421f90e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421f90e6",
  null
  
)

export default component.exports